import IntroSection from "../components/IntroSection";
import QualitySection from "../components/QualitySection";
import ProductSection from "../components/ProductSection";
import OEMSection from "../components/OEMSection";
import {ContactSection} from "../components/ContactSection";
import SendMessageSection from "../components/SendMessageSection";
import AskForDetail from "../components/AskForDetail";
import CustomerBrandSection from "../components/CustomerBrandSection";

function HomePage() {
    return (
        <>
            <IntroSection/>
            <QualitySection/>
            <ProductSection/>
            <OEMSection/>
            <AskForDetail/>
            <CustomerBrandSection/>
            <ContactSection/>
            <SendMessageSection/>
        </>
    );
}

export default HomePage;